const Intro = ()=>{
return(<div className="resume-intro py-3">
<div className="media flex-column flex-md-row align-items-center">
    <img
        className="resume-profile-image mb-3 mb-md-0 mr-md-5 ml-md-0 rounded-custom mx-auto"
        src="https://firebasestorage.googleapis.com/v0/b/cryosoft-corporation.appspot.com/o/SAVE_20210522_120828.png?alt=media&token=81428b39-1857-4349-9456-499a1a6668e2"
        alt="Karim K. Kanji's Profile"
    />
    <div className="media-body text-left">
        <strong>
            Senior ReactJS Developer at Cryosoft Corporation with over 6 years
            of experience developing ReactJS Apps.{" "}
        </strong>
        <p className="mb-0">
            <br />
            Strong believer in creating solutions and solving problems using
            Software. In my career, software is my core passion and what I
            enjoy doing the most. I love computers and have loved them since
            when I was a toddler back in 2002 where computers would facinate
            me and thus growing the passion in Computing and Information
            Technology.
        </p>
    </div>
    {/*//media-body*/}
</div>
</div>);
}
export default Intro;